import { motion } from 'motion/react';
import * as React from "react";

type buttonState = "open" | "closed";

interface IMenuButtonProps {
  onToggle?: (isOpen: boolean) => void;
  isOpen?: boolean;
}

const MenuButton: React.FC<IMenuButtonProps> = ({
    onToggle,
    isOpen = false,
}) => {
  return (
    <>
      {/* Menu/Close Button */}
      <div className="flex items-center justify-center shrink-0 size-[60px]">
        <button
          onClick={() => onToggle?.(!isOpen)}
          className="relative rounded-[8px] size-[40px] hover:bg-gray-100 transition-colors"
          aria-label={isOpen ? "Close menu" : "Open menu"}
        >
          <motion.div
            animate={
              isOpen ? { rotate: 45, y: 5 } : { rotate: 0, y: 0 }
            }
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="absolute bg-black h-[2px] left-[10px] rounded-[2px] top-[14px] w-[20px]"
          />
          <motion.div
            animate={
              isOpen ? { rotate: -45, y: -5 } : { rotate: 0, y: 0 }
            }
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="absolute bg-black h-[2px] left-[10px] rounded-[2px] top-[24px] w-[20px]"
          />
        </button>
      </div>
    </>
  );
};

export default MenuButton;
